import { defineMessages } from 'react-intl';

import type { i18nType } from '../../../../../common/types';

type FiltersControlMessages = Record<string, i18nType>;

export const i18n: FiltersControlMessages = defineMessages({
	buttonLabel: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.filters-control.buttonLabel',
		defaultMessage: 'All filters',
		description:
			'Accessibility label for the icon button at the end of the search filter row that opens every available filter',
	},
	buttonLabelWithCount: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.filters-control.buttonLabelWithCount',
		defaultMessage: 'All filters, {count} applied',
		description:
			'Accessibility label for the icon button at the end of the search filter row when some of the filters it opens have been applied. {count} is the number of applied filters.',
	},
	dropdownLabel: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.filters-control.dropdownLabel',
		defaultMessage: 'Filters',
		description:
			'Accessibility label for the panel of filters opened by the icon button at the end of the search filter row',
	},
});
